import React from "react";
import { Script } from "gatsby"
import clsx from "clsx";
import dompurify from 'isomorphic-dompurify';
import IconContainer from "../../IconContainer";
import * as youtubeStyles from "../../../../styles/widgets/youtube.module.scss";
import {useTranslation} from "react-i18next";

import {dompurifyConfig} from "../../../../utils/utils";

export const EmbeddedVideo = ({
    content, playingVideoIndex, setPlayingVideoIndex, backgroundColor, index,
}) => {
    const defaultIconPlayColor = "RED";
    const embeddedRef = React.useRef(null);
    const {t} = useTranslation();
    const [playing, setPlaying] = React.useState(false);
    const [iconColor, setIconColor] = React.useState(defaultIconPlayColor);
    const [hoverColor, setHoverColor] = React.useState("WHITE");
  const sanitizer = dompurify.sanitize;

    const props = {
        content, backgroundColor,
    };

    const changeIconColor = (color, hoverColor) => {
        setIconColor(color);
        setHoverColor(hoverColor);
    };

    const playVideo = () => {
        setPlaying(true);
        setPlayingVideoIndex(index);
        const iframeContent = embeddedRef?.current?.querySelector("iframe");

        if (iframeContent) {
            const symbol = iframeContent.src.indexOf("?") > -1 ? "&" : "?";
            iframeContent.src += symbol + "autoplay=1";
        }
    };

    const [script, setScript] = React.useState();

    React.useEffect(() => {
        setScript(embeddedRef?.current?.querySelector("script")?.src);

        setPlaying(playingVideoIndex === index);
        if (playingVideoIndex !== index) {
            setIconColor(defaultIconPlayColor);
            setHoverColor("WHITE");
        }
        if (playing) {
            const iframeContent = embeddedRef?.current?.querySelector("iframe");

            if (iframeContent) {
                iframeContent.setAttribute("style", "height: 100%; width: 100%; border: 0");
                iframeContent.setAttribute("title", content.title);
                iframeContent.removeAttribute("frameborder");
                iframeContent.removeAttribute("height");
                iframeContent.removeAttribute("width");
                const symbol = iframeContent.src.indexOf("?") > -1 ? "&" : "?";
                iframeContent.src += symbol + "autoplay=1";
            }
        }
    }, [embeddedRef, playing, index, playingVideoIndex, content?.title]);
    return playing ? (<div className={youtubeStyles.bloc} role="presentation">
        {script && (
            <Script async src={script}/>
        )}
        <div
        dangerouslySetInnerHTML={{ __html: sanitizer(content.html, dompurifyConfig) }}
            ref={embeddedRef}
            className={youtubeStyles.videoBackground}
            style={{
                backgroundColor: props.backgroundColor
            }}
        />
    </div>) : (<button
        className={youtubeStyles.bloc}
        onMouseEnter={() => changeIconColor("WHITE", "RED")}
        onMouseLeave={() => changeIconColor("RED", "WHITE")}
        onClick={() => playVideo()}
        onKeyDown={() => playVideo()}
        aria-label={t(`embedded.button.play`)}
    >
        <div className={`${youtubeStyles.overlay} ${youtubeStyles.writing}`}>
            <p className={youtubeStyles.h3Title}>
          <span
              className={clsx(youtubeStyles.textWithBackground, youtubeStyles.title)}
          >
            {content.title}
          </span>
            </p>
        </div>
        <div className={youtubeStyles.videoLight} style={{backgroundImage: `url(${props.content.thumbnailUrl})`}}>
            <button
                title={content.title}
                aria-label={t(`embedded.button.play`)}
                className={youtubeStyles.youtube}
            >
                <IconContainer
                    icon="YOUTUBE"
                    color={iconColor}
                    size={40}
                    hoverColor={hoverColor}
                />
            </button>
        </div>
    </button>);
};
